(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
      $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
      })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-sale-live-bar"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('top-sale-bar')) {

  class TopSaleBar extends HTMLElement {

    connectedCallback() {

      if (this.initialized) return;

      this.initialized = true;

      this.slides = Array.from(
        this.querySelectorAll('[data-sale-slide]')
      );

      if (!this.slides.length) return;

      this.currentIndex = this.slides.findIndex(
        slide => slide.classList.contains('is-active')
      );

      if (this.currentIndex < 0) {
        this.currentIndex = 0;
        this.slides[0].classList.add('is-active');
      }

      this.interval =
        parseInt(this.dataset.interval, 10) || 4000;

      this.duration =
        parseInt(this.dataset.duration, 10) || 400;

      this.autoplay =
        this.dataset.autoplay !== 'false';

      this.pauseOnHover =
        this.dataset.pauseHover === 'true';

      this.timer = null;
      this.transitionTimer = null;

      this.closeButton =
        this.querySelector('[data-sale-close]');


      /*
       * Close button
       *
       * Nothing is saved to localStorage/sessionStorage,
       * so the bar returns automatically after page reload.
       */
      this.handleClose = () => {
        this.stopAutoplay();
        this.hidden = true;
      };


      /*
       * Pause / resume events
       */
      this.handleMouseEnter = () => {
        this.stopAutoplay();
      };

      this.handleMouseLeave = () => {
        this.startAutoplay();
      };

      this.handleFocusIn = () => {
        this.stopAutoplay();
      };

      this.handleFocusOut = event => {

        if (!this.contains(event.relatedTarget)) {
          this.startAutoplay();
        }

      };


      /*
       * Shopify Theme Editor:
       * Show the offer block currently selected by merchant.
       */
      this.handleBlockSelect = event => {

        if (
          !event.target ||
          typeof event.target.closest !== 'function'
        ) {
          return;
        }

        const selectedSlide =
          event.target.closest('[data-sale-slide]');

        if (
          !selectedSlide ||
          !this.contains(selectedSlide)
        ) {
          return;
        }

        const selectedIndex =
          this.slides.indexOf(selectedSlide);

        if (selectedIndex < 0) return;

        this.stopAutoplay();
        this.showSlide(selectedIndex, true);
      };


      this.handleBlockDeselect = event => {

        if (
          event.detail &&
          event.detail.sectionId &&
          !this.closest(
            '#shopify-section-' + event.detail.sectionId
          )
        ) {
          return;
        }

        this.startAutoplay();
      };


      /*
       * Attach events
       */
      if (this.closeButton) {
        this.closeButton.addEventListener(
          'click',
          this.handleClose
        );
      }

      if (this.pauseOnHover) {

        this.addEventListener(
          'mouseenter',
          this.handleMouseEnter
        );

        this.addEventListener(
          'mouseleave',
          this.handleMouseLeave
        );

      }

      this.addEventListener(
        'focusin',
        this.handleFocusIn
      );

      this.addEventListener(
        'focusout',
        this.handleFocusOut
      );

      document.addEventListener(
        'shopify:block:select',
        this.handleBlockSelect
      );

      document.addEventListener(
        'shopify:block:deselect',
        this.handleBlockDeselect
      );


      this.updateAccessibility();
      this.startAutoplay();
    }


    disconnectedCallback() {

      this.stopAutoplay();

      clearTimeout(this.transitionTimer);

      if (this.closeButton) {

        this.closeButton.removeEventListener(
          'click',
          this.handleClose
        );

      }

      if (this.pauseOnHover) {

        this.removeEventListener(
          'mouseenter',
          this.handleMouseEnter
        );

        this.removeEventListener(
          'mouseleave',
          this.handleMouseLeave
        );

      }

      this.removeEventListener(
        'focusin',
        this.handleFocusIn
      );

      this.removeEventListener(
        'focusout',
        this.handleFocusOut
      );

      document.removeEventListener(
        'shopify:block:select',
        this.handleBlockSelect
      );

      document.removeEventListener(
        'shopify:block:deselect',
        this.handleBlockDeselect
      );

      this.initialized = false;
    }


    startAutoplay() {

      if (!this.autoplay) return;

      if (this.slides.length <= 1) return;

      if (this.hidden) return;

      this.stopAutoplay();

      this.timer = setInterval(() => {

        const nextIndex =
          (this.currentIndex + 1) %
          this.slides.length;

        this.showSlide(nextIndex);

      }, this.interval);

    }


    stopAutoplay() {

      if (this.timer) {

        clearInterval(this.timer);
        this.timer = null;

      }

    }


    showSlide(index, instant = false) {

      if (
        index < 0 ||
        index >= this.slides.length
      ) {
        return;
      }

      if (index === this.currentIndex) {
        return;
      }

      clearTimeout(this.transitionTimer);

      this.slides.forEach(slide => {
        slide.classList.remove('is-leaving');
      });

      const currentSlide =
        this.slides[this.currentIndex];

      const nextSlide =
        this.slides[index];


      if (instant) {

        this.slides.forEach((slide, slideIndex) => {

          slide.classList.toggle(
            'is-active',
            slideIndex === index
          );

          slide.classList.remove('is-leaving');

        });

        this.currentIndex = index;

        this.updateAccessibility();

        return;
      }


      currentSlide.classList.remove('is-active');
      currentSlide.classList.add('is-leaving');

      nextSlide.classList.remove('is-leaving');

      /*
       * Force browser to register the incoming
       * slide's starting position.
       */
      void nextSlide.offsetWidth;

      nextSlide.classList.add('is-active');

      this.currentIndex = index;

      this.updateAccessibility();


      this.transitionTimer = setTimeout(() => {

        currentSlide.classList.remove('is-leaving');

      }, this.duration + 80);

    }


    updateAccessibility() {

      this.slides.forEach((slide, index) => {

        const active =
          index === this.currentIndex;

        slide.setAttribute(
          'aria-hidden',
          active ? 'false' : 'true'
        );

      });

    }

  }


  customElements.define(
    'top-sale-bar',
    TopSaleBar
  );

}


  } catch(e) { console.error(e); }
})();
})();
